import { Input, Label } from "@monsterindia/global-ui-components";
import React, { useEffect, useState } from "react";
import { set, useForm } from "react-hook-form";

import { API_ENDPOINT } from "../../../constants/appConstant";
import { PercentageData } from "../../../constants/educationDetailsApop";
import { getYearData } from "../../../helpers/getMonthNumber";
import { useNetwork } from "../../../hooks/useNetwork";
import {
  CheckboxOptionType,
  DropdownOptionType,
  MasterDataType,
} from "../../../types";
import { PillController, SingleDropDownController } from "../../controllers";
import { ActionButtonContainer } from "../common/ActionButtonContainer";
import { Heading } from "../common/Heading";
import { LinkedInConsent } from "../common/Linkedin/LinkedinConsent";
import { LinkedinURL } from "../common/Linkedin/LinkedinURL";
import { BoardFields } from "./BoardFields";
import { EducationDetailsUIProps } from "./EducationDetails.types";
import { SpecializationFields } from "./SpecializationFields";
import { containsOther } from "./getSubmitData";
import "./styles.css";

export const EducationDetailsApopUI = ({
  prefilledData,
  closeApop,
  backBtnClickHandler,
  onSubmit,
  isSubmitAPILoading,
  flowType,
  showPercentage = true,
  formRef,
}: EducationDetailsUIProps) => {
  const {
    register,
    control,
    formState: { errors },
    handleSubmit,
    setValue,
    setError,
    getValues,
    clearErrors,
    resetField,
  } = useForm();

  const [qualificationData, setQualificationData] = useState<
    CheckboxOptionType[] | null
  >(null);
  const [specializationData, setSpecializationData] = useState<
    CheckboxOptionType[] | null
  >(null);
  const [collegeData, setCollegeData] = useState<CheckboxOptionType[] | null>(
    null,
  );
  const [educationTypeData, setEducationTypeData] = useState<
    CheckboxOptionType[] | null
  >(null);
  const [boardData, setBoardData] = useState<CheckboxOptionType[] | null>(null);
  const [mediumData, setMediumData] = useState<CheckboxOptionType[] | null>(
    null,
  );
  const [isBoard, setIsBoard] = useState(false);
  const [manualQualification, setManualQualification] = useState(false);
  const [manualSpecialization, setManualSpecialization] = useState(false);
  const [manualInstitute, setManualInstitute] = useState(false);
  const [isSpecificationDisabled, setIsSpecificationDisabled] = useState(true);

  const [showLinkedinURL, setShowLinkedinURL] = useState(true);
  // const [isAutoUpdateChecked, setIsAutoUpdateChecked] = useState(false);
  // const [showLinkedinConsent, setShowLinkedinConsent] = useState(true);

  const [isDropdownOptionLoading, setIsDropdownOptionLoading] = useState(false);

  const startYear = new Date().getFullYear() + 5;
  const yearData = getYearData(50, startYear);

  const { fetchData: fetchAPI } = useNetwork();

  const prefillDataHelper = async (prefillData: any) => {
    const { educationPrefillData, linkedInResponse } = prefillData;

    if (educationPrefillData) {
      const {
        highestQualification,
        specialization,
        yearOfPassing,
        college,
        educationType,
        board,
        medium,
      } = educationPrefillData;

      if (highestQualification) {
        if (highestQualification.id) {
          setValue("highestQualification", highestQualification);
        } else {
          setValue("qualification", highestQualification.text);
          setManualQualification(true);
          setValue("highestQualification", {
            value: "Other",
            text: "Other",
          });
        }
        if (
          highestQualification.text === "10th Class (X)" ||
          highestQualification.text === "12th Class (XII)"
        ) {
          setIsBoard(true);
          boardDropdownOptionsHandler();
        } else {
          setIsSpecificationDisabled(false);
          if (highestQualification.id) {
            specializationDropdownOptionsHandler(
              highestQualification.id as string,
            );
          } else {
            const qualificationData =
              await qualificationDropdownOptionsHandler("Other");

            if (qualificationData && qualificationData.length > 0) {
              await specializationDropdownOptionsHandler(
                qualificationData[0].id as string,
              );
            }
          }
        }
      }

      if (educationType) {
        await educationTypeOptionsHandler(educationType.text);
        setValue("educationType", educationType);
      } else {
        await educationTypeOptionsHandler();
      }

      if (yearOfPassing) {
        const passingYearOptionData = yearData.filter((year) => {
          return year.text === yearOfPassing.toString();
        });
        setValue("passingYear", passingYearOptionData[0]);
      }

      if (specialization) {
        if (specialization.id) {
          setValue("specialization", specialization);
        } else {
          setManualSpecialization(true);
          setValue("specialization", {
            value: "Other",
            text: "Other",
          });
          setValue("manualSpecialization", specialization.text);
        }
      }

      if (college) {
        if (college.id) {
          setValue("institute", college);
        } else {
          setValue("university", college.text);
          setValue("institute", {
            value: "Other",
            text: "Other",
          });
          setManualInstitute(true);
        }
      }

      if (board) {
        setValue("board", board);
        if (medium) {
          setValue("medium", medium);
        }
      }
    } else {
      await educationTypeOptionsHandler();
    }

    if (linkedInResponse) {
      const { linkedInConsent, url } = linkedInResponse;

      if (url) {
        setValue("linkedin", url);
        setShowLinkedinURL(false);
      } else {
        setShowLinkedinURL(true);
      }
      // if (linkedInConsent === false || linkedInConsent === true) {
      //   setValue("isToggled", linkedInConsent);
      //   setShowLinkedinConsent(false);
      // } else {
      //   setShowLinkedinConsent(true);
      //   setValue("isToggled", true);
      //   setIsAutoUpdateChecked(true);
      // }
    }
    // else {
    //   setShowLinkedinURL(true);
    //   setShowLinkedinConsent(true);
    //   setValue("isToggled", true);
    //   setIsAutoUpdateChecked(true);
    // }
  };

  useEffect(() => {
    if (prefilledData) {
      prefillDataHelper(prefilledData);
    } else {
      educationTypeOptionsHandler();
    }
  }, [prefilledData]);

  const clearErrorHandler = (field: string) => {
    clearErrors(field);
  };

  const qualificationDropdownOptionsHandler = async (qualification: string) => {
    setIsDropdownOptionLoading(true);
    const res = await fetchAPI(
      `${API_ENDPOINT().seekerProfile.masterDataMiddleware}?type=HIGHEST_QUALIFICATION&name=${qualification}`,
      "GET",
    );

    const masterQualificationData = (res.data as any)?.data as MasterDataType[];

    const updatedQualificationData =
      masterQualificationData && masterQualificationData.length > 0
        ? masterQualificationData.map((qualification) => {
            return {
              value: qualification.name,
              id: qualification.uuid,
              text: qualification.name,
            };
          })
        : null;

    setIsDropdownOptionLoading(false);
    setQualificationData(updatedQualificationData);

    return updatedQualificationData;
  };

  const specializationDropdownOptionsHandler = async (parentUuids: string) => {
    setIsDropdownOptionLoading(true);
    const res = await fetchAPI(
      `${API_ENDPOINT().seekerProfile.masterDataMiddleware}?type=Specialization&parentUuids=${parentUuids}`,
      "GET",
    );

    const masterSpecializationData = (res.data as any)
      ?.data as MasterDataType[];

    const updatedSpecializationData =
      masterSpecializationData && masterSpecializationData.length > 0
        ? masterSpecializationData.map((specialization) => {
            return {
              value: specialization.name,
              id: specialization.uuid,
              text: specialization.name,
            };
          })
        : null;

    setIsDropdownOptionLoading(false);
    setSpecializationData(updatedSpecializationData);
    if (updatedSpecializationData && updatedSpecializationData.length === 0) {
      setIsSpecificationDisabled(true);
    } else {
      setIsSpecificationDisabled(false);
    }
  };

  const collegeDropdownOptionsHandler = async (college: string) => {
    setIsDropdownOptionLoading(true);
    const res = await fetchAPI(
      `${API_ENDPOINT().seekerProfile.masterDataMiddleware}?type=COLLEGE&name=${college}`,
      "GET",
    );

    const masterCollegeData = (res.data as any)?.data as MasterDataType[];

    const updatedCollegeData =
      masterCollegeData && masterCollegeData.length > 0
        ? masterCollegeData.map((college) => {
            return {
              value: college.name,
              id: college.uuid,
              text: college.name,
            };
          })
        : null;

    setIsDropdownOptionLoading(false);
    setCollegeData(updatedCollegeData);
  };

  const mediumDropdownOptionsHandler = async (medium: string) => {
    setIsDropdownOptionLoading(true);
    const res = await fetchAPI(
      `${API_ENDPOINT().seekerProfile.masterDataMiddleware}?type=MEDIUM&name=${medium}`,
      "GET",
    );

    const masterMediumData = (res.data as any)?.data as MasterDataType[];

    const updatedMediumData =
      masterMediumData && masterMediumData.length > 0
        ? masterMediumData.map((medium) => {
            return {
              value: medium.name,
              id: medium.uuid,
              text: medium.name,
            };
          })
        : null;

    setIsDropdownOptionLoading(false);
    setMediumData(updatedMediumData);
  };

  const boardDropdownOptionsHandler = async () => {
    setIsDropdownOptionLoading(true);
    const res = await fetchAPI(
      `${API_ENDPOINT().seekerProfile.masterDataMiddleware}?type=BOARD`,
      "GET",
    );

    const masterBoardData = (res.data as any)?.data as MasterDataType[];

    const updatedBoardData =
      masterBoardData && masterBoardData.length > 0
        ? masterBoardData.map((board) => {
            return {
              value: board.name,
              id: board.uuid,
              text: board.name,
            };
          })
        : null;

    setIsDropdownOptionLoading(false);
    setBoardData(updatedBoardData);
  };

  const educationTypeOptionsHandler = async (
    selectedEducationType?: string,
  ) => {
    setIsDropdownOptionLoading(true);
    const res = await fetchAPI(
      `${API_ENDPOINT().seekerProfile.masterDataMiddleware}?type=EDUCATION_TYPE&limit=10`,
      "GET",
    );

    const masterEducationTypeData = (res.data as any)?.data as MasterDataType[];
    const updatedEducationTypeData =
      masterEducationTypeData && masterEducationTypeData.length > 0
        ? masterEducationTypeData.map((educationType) => {
            if (educationType.name === selectedEducationType) {
              return {
                value: educationType.name,
                id: educationType.uuid,
                text: educationType.name,
                selected: true,
              };
            }
            return {
              value: educationType.name,
              id: educationType.uuid,
              text: educationType.name,
            };
          })
        : null;

    setIsDropdownOptionLoading(false);
    setEducationTypeData(updatedEducationTypeData);
  };

  const onSubmitHandler = async (data: any) => {
    onSubmit(data, isSpecificationDisabled, isBoard);
  };

  return (
    <>
      {flowType !== "EDIT_PROFILE" && (
        <Heading
          headingText="Education Details"
          isMobile={window.innerWidth < 768}
          onCloseBtnClickHandler={() => {
            closeApop();
          }}
        />
      )}
      <form
        className={`l1-relative l1-flex l1-w-full l1-flex-col l1-gap-4 ${flowType === "EDIT_PROFILE" ? "" : "l1-mb-36 l1-mt-10 md:l1-mb-12 md:l1-mt-9"} `}
        id="educationDetailsForm"
        onSubmit={handleSubmit(onSubmitHandler)}
        noValidate
        ref={formRef}
      >
        {flowType !== "EDIT_PROFILE" && (
          <p className="l1-text-xs l1-text-gray-400">
            Tell recruiters about your educational qualifications
          </p>
        )}

        <div className="l1-flex l1-flex-col l1-gap-4">
          {flowType !== "EDIT_PROFILE" && showLinkedinURL ? (
            <LinkedinURL
              register={register}
              setValue={setValue}
              errors={errors}
              setError={setError}
              clearError={() => clearErrors("linkedin")}
            />
          ) : null}

          <Label
            labelText={
              showPercentage ? "Highest Qualification" : "Qualification"
            } //showPercentage prop used here to change the heading in Profile page only
            isRequired={true}
            className="!l1-text-sm"
          >
            <SingleDropDownController
              name="highestQualification"
              control={control}
              isRequired={true}
              placeholder="Select your degree"
              isSearchable={true}
              options={qualificationData ?? []}
              isLoading={isDropdownOptionLoading}
              onChangeHandler={(inputText: string) => {
                qualificationDropdownOptionsHandler(inputText);
              }}
              onSelect={(value: DropdownOptionType) => {
                clearErrors("highestQualification");
                setValue("highestQualification", value);
                if (value && value?.text) {
                  setManualQualification(containsOther(value.text));
                }
                resetField("specialization");
                resetField("manualSpecialization");
                resetField("institute");
                resetField("university");
                resetField("board");
                resetField("medium");
                resetField("percentage");
                if (value && value.text) {
                  if (
                    value.text === "10th Class (X)" ||
                    value.text === "12th Class (XII)"
                  ) {
                    setIsBoard(true);
                    if (value.id) {
                      boardDropdownOptionsHandler();
                    }
                  } else {
                    setIsBoard(false);
                    setIsSpecificationDisabled(false);
                    if (value.id) {
                      specializationDropdownOptionsHandler(value.id as string);
                    }
                  }
                }
              }}
              errorMessage={
                errors.highestQualification ? "This field is required" : ""
              }
            />
          </Label>

          {manualQualification && (
            <Label
              labelText="Enter Your Qualification"
              isRequired={true}
              className="!l1-text-sm"
            >
              <Input
                id="qualification"
                placeholder="Enter Your Qualification"
                {...register("qualification", { required: true })}
                errorText={errors.qualification ? "This field is required" : ""}
              />
            </Label>
          )}

          {/* Specialization/Major, University/Institute, Board, Medium, Percentage, Passing Year, Education Type */}
          {isBoard ? (
            <BoardFields
              register={register}
              control={control}
              errors={errors}
              setValue={setValue}
              resetField={resetField}
              clearErrors={clearErrorHandler}
              isDropdownOptionLoading={isDropdownOptionLoading}
              boardData={boardData}
              mediumData={mediumData}
              percentageData={PercentageData}
              boardDropdownOptionsHandler={boardDropdownOptionsHandler}
              mediumDropdownOptionsHandler={mediumDropdownOptionsHandler}
              showPercentage={showPercentage}
            />
          ) : (
            <SpecializationFields
              register={register}
              control={control}
              errors={errors}
              getValues={getValues}
              setValue={setValue}
              resetField={resetField}
              clearErrors={clearErrorHandler}
              isDropdownOptionLoading={isDropdownOptionLoading}
              specializationData={specializationData}
              collegeData={collegeData}
              specializationDropdownOptionsHandler={
                specializationDropdownOptionsHandler
              }
              collegeDropdownOptionsHandler={collegeDropdownOptionsHandler}
              isSpecificationDisabled={isSpecificationDisabled}
              manualSpecialization={manualSpecialization}
              manualInstitute={manualInstitute}
              setManualSpecialization={(value) =>
                setManualSpecialization(value)
              }
              setManualInstitute={(value) => setManualInstitute(value)}
            />
          )}

          <Label
            labelText="Passing Year"
            isRequired={true}
            className="!l1-text-sm"
          >
            <SingleDropDownController
              name="passingYear"
              control={control}
              isRequired={true}
              placeholder="Select year"
              isSearchable={false}
              options={yearData}
              isLoading={isDropdownOptionLoading}
              onSelect={(value: DropdownOptionType) => {
                clearErrors("passingYear");
                setValue("passingYear", value);
              }}
              errorMessage={errors.passingYear ? "This field is required" : ""}
            />
          </Label>

          {educationTypeData && educationTypeData.length > 0 ? (
            <Label
              labelText="Education Type"
              isRequired={true}
              className="!l1-text-sm"
            >
              <PillController
                name="educationType"
                size="medium"
                selectType="single"
                control={control}
                options={educationTypeData}
                isRequired={true}
                onSelect={(value: DropdownOptionType[]) => {
                  clearErrors("educationType");
                  setValue("educationType", value[0]);
                }}
                errorMessage={
                  errors.educationType ? "This field is required" : ""
                }
              />
            </Label>
          ) : null}

          {/* {flowType !== "EDIT_PROFILE" && showLinkedinConsent ? (
            <LinkedInConsent
              checked={isAutoUpdateChecked}
              handleConsentToggle={(e: React.ChangeEvent<HTMLInputElement>) => {
                setValue("isToggled", e.target.checked);
                setIsAutoUpdateChecked(e.target.checked);
              }}
            />
          ) : null} */}
        </div>

        {flowType !== "EDIT_PROFILE" ? (
          <ActionButtonContainer
            primaryBtnLabel="Save"
            isLoading={isSubmitAPILoading}
          />
        ) : (
          <>
            {/* showPercentage condition added to hide button in profile page */}
            {showPercentage && (
              <ActionButtonContainer
                primaryBtnLabel="Save"
                secondaryBtnLabel="Cancel"
                secondaryBtnOnClick={backBtnClickHandler}
                isLoading={isSubmitAPILoading}
              />
            )}
          </>
        )}
      </form>
    </>
  );
};
